
let ruleResultMessage = (type, body) => {
    return {
        type,
        body
    }
}

let ruleResult = (id, name, success, message) => {
    return {
        id,
        name,
        success,
        message
    }
}

let pipelineResult = (id, name, context, ruleResults) => {

    let success = false
    if (ruleResults && ruleResults.length > 0) {
        let failures = ruleResults.filter((r) => r.success === false)
        success = failures.length > 0 ? false : true
    }

    return {
        id,
        name,
        context,
        success,
        ruleResults
    }
}

export { ruleResultMessage, ruleResult, pipelineResult }